import React, { useEffect, useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next';
import { colors, glyphs } from '../../Styles';
import { EventNotePopover, Overlay, AddEventModal, ReactiveTable } from '..';
import { ButtonTypes, ListData_ValueTypes, TableStyles_Types } from '../../Definitions';
import { useAppDispatch, useAppSelector } from '../../Store';
import { getCoreRowModel, useReactTable } from '@tanstack/react-table';
import { NewButtonList } from '../BaseComponents/';
import { dispatchFetchAnimalEvent, selectEventByAnimal } from '../../Services/Agrisys_GqlDataCaller/EventsDataCalls/eventsSlice';
import { useColumnConstructor } from '../Tables/_Tables/useColumnConstructor';

interface Events_Props {
  selectedAnimal: number
}
/**
 * Events
 * @param selectedAnimal
 * @returns
 */
export default function Events({ selectedAnimal }:Events_Props) {
  const {t} = useTranslation()
  const [addEventModal, setAddEventModal] = useState(false)
  const [editTable, setEditTable] = useState(false);
  
  const dispatch = useAppDispatch();
  
  dispatch(dispatchFetchAnimalEvent(selectedAnimal))
  
  

  const event = useAppSelector(state => selectEventByAnimal(state, selectedAnimal))
  // const event = useMemo(() => [],[]);

  const tableData = useMemo(() => {
    return event && event.length > 0
      ? event.map((event, index, arr) => {
          const notes = event.note || "";
          const date = new Date(event.timestamp);

          return { 
            eventType: event.eventName, 
            // eventDate: new LocaleFarmDate(event.timestamp).toDateForDisplay(),
            eventDate: `${date.toLocaleDateString("da-DK")} ${date.toLocaleTimeString("da-DK")}`,
            eventNotes: event.note ? (
              <EventNotePopover 
                eventName={event.eventName} 
                eventNote={notes} 
                glyphColor={colors.greyDarkPrimary} 
              />
            ) : <></>,
            id: event.eventNo 
          };
        })
      : [];
  }, [event]);

  // #region | Events Table
  const accessorData = useMemo(() => ([
    {headerValue: t("animalPages.animal.eventType", {defaultValue: "type"}), accessor: "eventType", type: ListData_ValueTypes.String},
    {headerValue: t("animalPages.animal.eventDate", {defaultValue: "date"}), accessor: "eventDate", type: ListData_ValueTypes.String},
    {headerValue: t("animalPages.animal.eventNote", {defaultValue: "note"}), accessor: "eventNotes", type: ListData_ValueTypes.Div},
  ]),[t])
  
  const columns = useColumnConstructor({
    accessorData: [...accessorData],
    tableStyle: TableStyles_Types.primaryTable, 
    canEdit: editTable 
  });
  
  const table = useReactTable({
    columns,
    data: tableData,
    getCoreRowModel: getCoreRowModel(),
  })
  
  const reactiveTable = <>{ReactiveTable({table, tableType: TableStyles_Types.primaryTable, emptyText: "No animal events", renderFooter: false, minRows: 7})}</>
  // #endregion

  return ( <>
    { editTable ? <Overlay/> : <></> }
    <div style={{position: "relative", height: "calc(100% - 50px)"}}>
        <div style={{display: "flex", position: "relative", justifyContent: "end", padding: "0px 20px", zIndex: editTable? "9999" : "0"}}>
        { editTable 
          ? <NewButtonList
              contents={[t("buttons.save", {defaultValue: "Save"}), t("buttons.cancel", {defaultValue: "cancel"}), t("buttons.add", {defaultValue: "add"})]}
              buttonType={ButtonTypes.tableButton}
              startEnhancers={[glyphs.Check({}), glyphs.Close({}), glyphs.Add({}), glyphs.Edit({}) ]}
              onClick={(i => {
                if (i === 0) {} // TODO: Save to db
                if (i === 1) {setEditTable(false)}
              })}
              disabled={[false, false, true]}
              overrides={(index: number) => ({
                baseStyles: {backgroundColor: index === 3 ? colors.greyPrimary : colors.greySecondary},
                hoverStyles: {backgroundColor: colors.greyPrimary},
                disabledStyles: {opacity: index === 3 ? 1 : 0.5},
              })}
            /> 
          : <NewButtonList
              contents={[t("buttons.add", {defaultValue: "add"})]}
              buttonType={ButtonTypes.tableButton}
              startEnhancers={[ glyphs.Add({}), glyphs.Edit({}) ]}
              onClick={(i => {
                if (i === 0) {setAddEventModal(true)} 
              })}
          />
        }
      </div>
      <div style={{height: "100%", boxSizing: "border-box", position: "relative", zIndex: editTable? "9999" : "0", backgroundColor: colors.greyLightSecondary, border: "5px solid "+colors.greyPrimary, borderRadius: "10px", overflowY: "hidden"}}>
        {reactiveTable}
      </div>
    </div>
    {selectedAnimal && <AddEventModal isModalOpen={addEventModal} closeModal={() => setAddEventModal(false)} animalId={selectedAnimal}/>}
  </> );
}